import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Stack,
  CircularProgress,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Helmet } from 'react-helmet-async';
import Services from 'src/services/Services';
import { tokenService } from 'src/services';

export default function FaqPage() {
  const token = tokenService?.getUser()?.token; // Token'ı alın

  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const type =
      tokenService.getUser()?.accountCategory === 'store' ? 'store' : 'porter';
    setLoading(true);
    Services.GetFaq(token, type)
      .then((res) => {
        console.log(res.data);
        if (res.data.status) {
          setAllData(res.data.result);
          setFilteredData(res.data.result);
        } else {
          setAllData([]);
          setFilteredData([]);
        }
      })
      .catch((err) => {
        console.error(err);
        setAllData([]);
        setFilteredData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token]);

  useEffect(() => {
    if (!searchText.trim()) {
      setFilteredData(allData);
    } else {
      const lowerSearch = searchText.toLowerCase();
      const filtered = allData.filter(
        (item) =>
          (item.title && item.title.toLowerCase().includes(lowerSearch)) ||
          (item.description &&
            item.description.toLowerCase().includes(lowerSearch))
      );
      setFilteredData(filtered);
    }
  }, [searchText, allData]);
  const handleAccordionChange = (panelId) => (event, isExpanded) => {
    setExpanded(isExpanded ? panelId : false);
  };

  if (loading) {
    return (
      <Stack height="100vh" alignItems="center" justifyContent="center">
        <CircularProgress />
      </Stack>
    );
  }

  return (
    <>
      <Helmet>
        <title>Sıkça Sorulan Sorular</title>
      </Helmet>
      <Box sx={{ p: { xs: 2, md: 3 } }}>
        <Typography variant="h4" gutterBottom>
          Sıkça Sorulan Sorular (SSS)
        </Typography>
        <TextField
          fullWidth
          label="Ara"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          variant="outlined"
          sx={{ my: 2, width: 300, backgroundColor: 'white', mb: 3 }}
        />

        {filteredData?.length === 0 ? (
          <Typography>Veri Bulunamadı.</Typography>
        ) : (
          filteredData?.map((item, index) => (
            <Accordion
              key={item.id || index}
              expanded={expanded === item.id}
              onChange={handleAccordionChange(item.id)}
              sx={{
                borderColor: '#ccc',
                mb: 2,
                borderRadius: 1,
                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                width: '100%',
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${item.id}-content`}
                id={`panel${item.id}-header`}
                sx={{
                  backgroundColor:
                    expanded === item.id ? '#F3F4F6' : 'transparent',
                  borderBottomColor: '#ccc',
                  borderBottomStyle: 'solid',
                }}
                style={{ height: '56px', minHeight: '56px' }}
              >
                <Typography variant="subtitle1" sx={{ flexWrap: 'wrap' }}>
                  {item.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  borderTopColor: '#ccc',
                  borderTopWidth: 1,
                  borderTopStyle: 'solid',
                }}
              >
                <Typography
                  sx={{
                    mt: 2,
                    color: '#9CA3AF',
                    fontSize: 16,
                  }}
                >
                  {item.description}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))
        )}
      </Box>
    </>
  );
}
